// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Form } from 'antd';
import { FormListProps } from 'antd/lib/form';

import './List.scss';

type ListProps = FormListProps;

export const List = ({ children, ...props }: ListProps): ReactElement => <Form.List {...props}>{children}</Form.List>;
